module.exports = __webpack_public_path__ + "static/media/Logo-LA COMER.bdf0fe9c.jpeg";